import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IConstructiveSteps {
    rt_projeto?: string,
    ano_projeto?: number,
    empresa_construtora?: string,
    rt_obra?: string,
    empresa_fiscalizadora_ato?: string,
    rt_fiscalizacao_ato?: string,
    ano_construcao?: number,
    as_built_as_is?: string,
    empresa_executora_as_built_as_is?: string,
    ano_as_built_as_is?: number,
    elevacao?: number,
    empresa_projetista?: string,
    uuid?: string,
    filename?: string,
    id_tipo?: string,
    rt_as_built_as_is?: string,
}


const create = async (data: IConstructiveSteps[], uuid: string): Promise<IConstructiveSteps | Error > => {
    await AuthService.verify();
    
    try {
        const token = await AuthService.getAccessToken();

        const dataWithoutFilenameIdTipo = data.map(step => {
            const { filename, id_tipo, ...rest } = step;
            return rest;
        });

        const response = await ApiBack.post(`./projetoconstrutivo/etapa?uuid=${uuid}`, dataWithoutFilenameIdTipo, {
            headers: {
                Authorization: `${token}` 
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao criar arquivo');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar arquivo');
        }
    }
};

const update = async (data: IConstructiveSteps[], uuid: string) => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./projetoconstrutivo/etapa?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}` 
            }
        });

        if (response.data) {
            return response;
        }

        return new Error('Erro ao criar arquivo');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar arquivo');
        }
    }
};

const get = async(uuid: string): Promise<IConstructiveSteps[] | Error> => {

    await AuthService.verify();

    try {

        const token = await AuthService.getAccessToken();

        const { data } = await ApiBack.get(`./projetoconstrutivo/etapas?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (data) {
            return data;
        }

        return new Error('Erro ao buscar registros.');

    } catch (error) {
        console.error(error);
        return new Error((error as { message: string}).message || 'Erro ao buscar registros.');
    }
};

const deleteById = async(uuid: string): Promise<string | Error> => {
    await AuthService.verify();

    try {

        const token = await AuthService.getAccessToken();

        const { data } = await ApiBack.delete(`./projetoconstrutivo/etapa?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(data){
            return data;
        }

        return new Error('Erro ao deletar registro');

    } catch (error) {
        return new Error((error as { message: string}).message || 'Erro ao deletar registros.');
    }
};


export const ConstructiveStepsServices = {
    create,
    update,
    get,
    deleteById
};